module.exports = __webpack_public_path__ + "img/defaultImg404.a7a6d4bc.png";